// @flow
import * as React from 'react'
import './styles.scss'
import { Heading, TextField, Stack, Card } from '@shopify/polaris'
const ColorPicker = require('rc-color-picker');

type Props = {    
    type: String,
    settings: Object,
    changeTextSettings: (a: Object) => void,
}

type State = {  
    
}

export default class TextSettings extends React.Component<Props, State> {
    
    render() {
        const { type, changeTextSettings, settings } = this.props;
        let handleSettings;    
        if(type === 'wishlist') {
            let {wishlist_enable,wishlist_product_number, updated_at, wishlist_add_to_cart_class, wishlist_layout, launch_add, launch_show, redirect_wishlist, records_per_page, wishlist_add_class,wishlist_show_class,wishlist_remove_class,add_class_icon,show_class_icon,remove_class_icon,...rest} = settings;
            handleSettings = rest;
        } else {
            let {compare_options, compare_layout, launch_add, updated_at, launch_show, compare_enable, compare_product_number,compare_add_class,compare_show_class,compare_remove_class,add_class_icon,show_class_icon,remove_class_icon,...rest} = settings;
            handleSettings = rest;
        }
        
        const settingContent = Object.keys(handleSettings).map((settingKey, index) => {
            const settingVal = handleSettings[settingKey];
            let labelTexts = settingKey.split("_");
            let labelText = labelTexts.slice(1, labelTexts.length);
            labelText = labelText.join(" ")
            return (
                <React.Fragment key={`${settingKey}-${index}`}>
                    <TextField
                        label={labelText}
                        value={settingVal}
                        multiline={labelText == "Notify Added" ? 2 : 1}
                        onChange={(val) => {
                            changeTextSettings(type, {[settingKey]: val})
                        }}
                    />
                </React.Fragment>
            )
        })
        
        return (
            <Card sectioned>
                <div className='text-settings'>
                    {/** Add Icon Size */}
                    <Heading>{ type === 'wishlist' ? 'Translation for wishlist' : 'Translation for compare'}</Heading>
                    <Stack distribution="fillEvenly" vertical> 
                        { settingContent }
                    </Stack>
                </div>
            </Card>
        )
    }
}